import { environment } from '@env/environment';
import { ConfigService } from './config.service';
import { CommonService } from './core/services/common.service';
import { HttpClient } from '@angular/common/http';

export function loadConfig(configService: ConfigService, commonService: CommonService, http: HttpClient) {
  return () => {
    return http.get(environment.API_URL + 'main/getMetadata') 
      .toPromise()
      .then(response => {
        localStorage.setItem('bWV0YURhdGFDb25maWc=', response['DATA']);
        let instance = window.location.host.split(".")[0].replace('staging-', '');
        let formData = new FormData();
        formData.append("instance", instance);

        return configService.loadConfig(formData).toPromise().then(config => {
          configService.setConfig(config);

          let obj = {
            "instance": instance,
            "instanceId": config['DATA'].INSTANCEID,
            "logo": config['DATA'].LOGO,
            "whiteLogo": config['DATA'].WHITELOGO
          };

          let logo = JSON.stringify({
            "whiteTheme": config['DATA'].WHITELOGO,
            "normalLogo": config['DATA'].LOGO
          });

          commonService.setCookie(
            environment.instanceCookie,
            commonService.encrypt(JSON.stringify(obj)),
            10000,
            environment.domain,
            '/'
          );
          localStorage.setItem('banner', config['DATA'].BANNER);
          localStorage.setItem('logo', logo);
        }).catch(error => {
          console.log('Failed to load instance config', error);
          throw error;
        });
      })
      .catch(error => {
        console.log('Failed to load metadata', error);
        return Promise.resolve();  // Avoid blocking bootstrap
      });
  };
}
